// extracted by mini-css-extract-plugin
module.exports = {"submitButtonWrapper":"form_submitButtonWrapper__TVf11"};